// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes home-ad-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 18px, 0) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes home-ad-enter-sync {
  from {
    opacity: 0;
    transform: translate3d(12px, 0, 0) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
.home-page {
  position: relative;
  width: 100%;
  padding: 24px 0 0;
}
.home-page .title-home, .home-page .title-section {
  font-family: Campuni, Figtree, "Open Sans";
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  margin-bottom: 30px;
}
.home-page p {
  font-size: 13px;
  line-height: 1.3;
}
.home-page picture {
  margin: 32px 0;
}
.home-page picture img {
  width: 100%;
  object-fit: cover;
}
.home-page .card-projected {
  padding: 0 7px;
  height: 70px;
}
.home-page .card-projected-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.home-page .card-projected figure {
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100px;
}
.home-page .card-projected .text {
  max-width: 62%;
}
.home-page .card-projected h2 {
  font-size: 14px;
  margin-bottom: 5px;
}
.home-page .card-projected p {
  font-size: 11px;
}
.home-page .line {
  display: block;
  width: 100%;
  height: 1px;
  background: var(--sebrae-light-gray4);
  margin: 32px 0;
}
.home-page .content {
  margin-bottom: 30px;
}
.home-page .content .salutation {
  margin-bottom: 32px;
}
.home-page .content .salutation h2 {
  font-size: 32px;
  font-weight: 700;
  font-family: "Campuni";
  color: var(--sebrae-gray);
}
.home-page .content .salutation h2 span {
  color: var(--sebrae-blue);
}
.home-page .content-left {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.home-page .content-left__hero-panel, .home-page .content-left__ad-panel {
  min-width: 0;
}
.home-page .content-left__hero-panel {
  transition: width 700ms ease, flex-basis 700ms ease, max-width 700ms ease;
}
.home-page .content-left__ad-panel {
  width: 100%;
}
.home-page .content-left--ad-animating .home-hero__content picture {
  transition: opacity 520ms ease;
  opacity: 0;
}
.home-page .content-left--ad-animating .home-hero__image {
  transition: opacity 520ms ease;
  opacity: 0;
}
.home-page .content-left__ad-slot {
  width: 100%;
  transform-origin: center;
  will-change: opacity, transform;
  opacity: 1;
}
.home-page .content-left__ad-slot .transbordo-ad {
  container-type: inline-size;
  max-width: 571px !important;
}
.home-page .content-left__ad-slot .transbordo-ad__close {
  font-size: 20px !important;
}
.home-page .content-left__ad-slot .transbordo-ad__cta {
  width: 100% !important;
}
@media screen and (max-width: 641px) {
  .home-page .content-left__ad-slot .transbordo-ad[data-rule-key=G1] {
    max-width: none !important;
    width: 100% !important;
  }
  .home-page .content-left__ad-slot .transbordo-ad[data-rule-key=G1] + .transbordo-ad__aside {
    display: none !important;
  }
}
@container (max-width: 530px) {
  .home-page .content-left__ad-slot .transbordo-ad__actions {
    flex-direction: column !important;
    gap: 12px !important;
  }
}
.home-page .content-left__ad-slot--entering {
  animation: home-ad-enter-sync 700ms ease both;
}
.home-page .content-middle {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
}
.home-page .things-to-do,
.home-page .simulations {
  background: var(--sebrae-white);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1019607843);
  border: 1px solid var(--sebrae-light-gray4);
  border-radius: 8px;
  padding: 24px 16px;
}
.home-page .things-to-do__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.home-page .things-to-do__item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 12px;
  border-radius: 10px;
  background: #f1f6ff;
}
.home-page .things-to-do__item p {
  margin: 0;
  font-size: 16px;
  color: var(--sebrae-blue-2);
}
.home-page .things-to-do__icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #84F4BC;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-page .things-to-do__icon svg {
  display: block;
  width: 16px;
  height: 16px;
}
.home-page .things-to-do__link {
  display: block;
  width: 100%;
  margin-top: 16px;
  border: 0;
  color: var(--sebrae-blue);
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}
.home-page .simulations p {
  margin-bottom: 24px;
}
.home-page .simulations .comparison-lab-container {
  max-width: 100%;
  gap: 0;
  margin-bottom: 24px;
}
.home-page .simulations .comparison-lab-container:last-child {
  margin-bottom: 0;
}
.home-page .simulations .comparison-lab-container svg {
  width: 100%;
  height: auto;
  margin-left: 0;
}
.home-page .simulations .card-pill {
  max-width: 100%;
  border: 0;
  box-shadow: none;
}
.home-page .card-pill.right .card-pill__text {
  background: transparent;
}
.home-page .modal-default.dialog-alert .title {
  font-size: 16px;
}
.home-page .modal-default.dialog-alert .wrapper-modal {
  max-width: 405px;
}
.home-page .modal-default.dialog-alert .dialog-alert__description {
  font-size: 14px;
}
.home-page .modal-default.dialog-alert .dialog-alert__description strong {
  font-size: inherit;
}
.home-page .modal-default.dialog-alert .dialog-alert__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 24px;
}
.home-page .modal-default.dialog-alert .dialog-alert__buttons button {
  min-height: 32px;
  padding: 5px 12px;
}
.home-page .modal-default.dialog-alert .dialog-alert__buttons span {
  font-size: 14px;
}
@media screen and (min-width: 375px) {
  .home-page .card-projected {
    height: 87px;
    padding: 0 10px;
  }
  .home-page .card-projected figure {
    width: 125px;
    left: 10px;
  }
  .home-page .card-projected .text {
    max-width: 58%;
  }
  .home-page .card-projected h2 {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) {
  .home-page .title-home {
    font-size: 28px;
  }
  .home-page p {
    font-size: 16px;
  }
  .home-page p strong {
    font-size: 24px;
  }
  .home-page .title-section {
    font-size: 23px;
  }
  .home-page .card-projected {
    width: 98%;
    margin: 0 auto;
    transform: skewX(-10deg);
  }
  .home-page .card-projected-content {
    transform: skewX(10deg);
    justify-content: flex-start;
    padding-left: 150px;
  }
  .home-page .card-projected figure {
    bottom: -7px;
  }
  .home-page .card-projected .text {
    max-width: 100%;
  }
  .home-page .card-projected .text p {
    font-size: 13px;
  }
  .home-page .card-projected .border {
    display: none;
  }
  .home-page .things-to-do,
  .home-page .simulations {
    padding: 37.5px 24px;
  }
  .home-page .things-to-do .title-section,
  .home-page .simulations .title-section {
    font-size: 27px;
  }
  .home-page .things-to-do__item {
    gap: 16px;
  }
}
@media screen and (min-width: 992px) {
  .home-page .content {
    width: 100%;
    justify-content: space-between;
  }
  .home-page .content-left {
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    overflow: visible;
  }
  .home-page .content-left__hero-panel, .home-page .content-left__ad-panel {
    min-width: 0;
    transition: flex-basis 700ms cubic-bezier(0.22, 1, 0.36, 1), max-width 700ms cubic-bezier(0.22, 1, 0.36, 1), width 700ms cubic-bezier(0.22, 1, 0.36, 1), opacity 420ms ease;
  }
  .home-page .content-left__hero-panel {
    flex: 0 1 100%;
    max-width: 100%;
  }
  .home-page .content-left__hero-panel .home-hero {
    width: 100%;
    transition: transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
    transform-origin: left center;
  }
  .home-page .content-left__ad-panel {
    flex: 0 0;
    max-width: 0;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    padding: 0;
    box-sizing: border-box;
  }
  .home-page .content-left--has-pending-ad .content-left__hero-panel {
    flex-basis: 100%;
    max-width: 100%;
  }
  .home-page .content-left--has-pending-ad .content-left__ad-panel {
    flex-basis: 0%;
    max-width: 0;
  }
  .home-page .content-left--ad-animating .content-left__hero-panel, .home-page .content-left--ad-visible .content-left__hero-panel {
    flex-basis: 58%;
    max-width: 58%;
  }
  .home-page .content-left--ad-animating .content-left__ad-panel, .home-page .content-left--ad-visible .content-left__ad-panel {
    flex-basis: 42%;
    max-width: 42%;
    opacity: 1;
    pointer-events: auto;
    overflow: visible;
    padding: 12px 10px;
  }
  .home-page .content-left--ad-animating .home-hero__content picture.home-hero__media, .home-page .content-left--ad-visible .home-hero__content picture.home-hero__media {
    width: 480.2px;
    max-width: none;
  }
  .home-page .content-left--ad-animating .home-hero__content picture.home-hero__media--monitoring-reminder, .home-page .content-left--ad-visible .home-hero__content picture.home-hero__media--monitoring-reminder {
    width: 700px;
    max-width: none;
  }
  .home-page .content-left--ad-animating .home-hero__content picture.home-hero__media--monitoring-overdue, .home-page .content-left--ad-visible .home-hero__content picture.home-hero__media--monitoring-overdue {
    width: 789.14px;
    max-width: none;
  }
  .home-page .content-left--ad-visible .home-hero__content picture {
    opacity: 0;
  }
  .home-page .content-middle {
    width: 100%;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
  }
  .home-page .content > div:last-child {
    width: 100%;
  }
  .home-page .things-to-do {
    width: 60%;
  }
  .home-page .things-to-do .title-section {
    text-align: left;
    margin-bottom: 24px;
  }
  .home-page .simulations {
    width: 40%;
    padding: 37.5px 24px;
  }
  .home-page .simulations .title-section {
    text-align: left;
    margin-bottom: 8px;
  }
  .home-page .simulations p {
    font-size: 13px;
    font-weight: 400;
    color: var(--sebrae-gray);
  }
  .home-page .card-projected {
    margin-top: 51px;
  }
  .home-page .card-pill {
    border-radius: 4px;
  }
  .home-page .line {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .home-page .content-left,
  .home-page .content-left__ad-slot,
  .home-page .content-left__hero-panel,
  .home-page .content-left__ad-panel,
  .home-page .content-left--ad-animating .home-hero,
  .home-page .content-left--ad-animating .home-hero__content picture,
  .home-page .content-left--ad-animating .home-hero__image {
    animation: none;
    transition: none;
  }
  .home-page .content-left__ad-slot {
    animation: none;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/index.scss"],"names":[],"mappings":"AACE;EACE;IACE,UAAA;IACA,8CAAA;EAAJ;EAGE;IACE,UAAA;IACA,wCAAA;EADJ;AACF;AAIE;EACE;IACE,UAAA;IACA,+CAAA;EAFJ;EAKE;IACE,UAAA;IACA,wCAAA;EAHJ;AACF;AAnBA;EAyBE,kBAAA;EACA,WAAA;EACA,iBAAA;AAHF;AAKE;EAEI,0CAAA;EACA,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,mBAAA;AALJ;AAOE;EACE,eAAA;EACA,gBAAA;AALJ;AAOE;EACE,cAAA;AALJ;AAOI;EACE,WAAA;EACA,iBAAA;AALN;AAQE;EACE,cAAA;EACA,YAAA;AANJ;AAQI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AANN;AAQI;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;AANN;AAQI;EACE,cAAA;AANN;AAQI;EACE,eAAA;EACA,kBAAA;AANN;AAQI;EACE,eAAA;AANN;AASE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,cAAA;AAPJ;AASE;EACE,mBAAA;AAPJ;AASI;EACE,mBAAA;AAPN;AASM;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAPR;AASQ;EACE,yBAAA;AAPV;AAYI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAVN;AAYM;EAEE,YAAA;AAXR;AAcM;EACE,yEAAA;AAZR;AAeM;EACE,WAAA;AAbR;AAiBQ;EACE,8BAAA;EACA,UAAA;AAfV;AAkBQ;EACE,8BAAA;EACA,UAAA;AAhBV;AAoBM;EACE,WAAA;EACA,wBAAA;EACA,+BAAA;EACA,UAAA;AAlBR;AAoBQ;EACE,2BAAA;EACA,2BAAA;AAlBV;AAqBQ;EACE,0BAAA;AAnBV;AAsBQ;EACE,sBAAA;AApBV;AAuBQ;EACE;IACE,0BAAA;IACA,sBAAA;EArBV;EAwBQ;IACE,wBAAA;EAtBV;AACF;AAyBQ;EACE;IACE,iCAAA;IACA,oBAAA;EAvBV;AACF;AA0BQ;EACE,6CAAA;AAxBV;AA6BI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AA3BN;AA8BE;;EAEE,+BAAA;EACA,uDAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;AA5BJ;AA+BI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7BN;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AA9BN;AAgCM;EACE,SAAA;EACA,eAAA;EACA,2BAAA;AA9BR;AAkCI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhCN;AAkCM;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAhCR;AAoCI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAlCN;AAsCI;EACE,mBAAA;AApCN;AAuCI;EACE,eAAA;EACA,MAAA;EACA,mBAAA;AArCN;AAuCM;EACE,gBAAA;AArCR;AAwCM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAtCR;AA0CI;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AAxCN;AA4CI;EACE,uBAAA;AA1CN;AA+CM;EACE,eAAA;AA7CR;AA+CM;EACE,gBAAA;AA7CR;AAgDQ;EACE,eAAA;AA9CV;AAgDU;EACE,kBAAA;AA9CZ;AAiDQ;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA/CV;AAiDU;EACE,gBAAA;EACA,iBAAA;AA/CZ;AAiDU;EACE,eAAA;AA/CZ;AAuDE;EACE;IACE,YAAA;IACA,eAAA;EArDJ;EAuDI;IACE,YAAA;IACA,UAAA;EArDN;EAuDI;IACE,cAAA;EArDN;EAuDI;IACE,eAAA;EArDN;AACF;AAwDE;EACE;IACE,eAAA;EAtDJ;EAwDE;IACE,eAAA;EAtDJ;EAwDI;IACE,eAAA;EAtDN;EAyDE;IACE,eAAA;EAvDJ;EAyDE;IACE,UAAA;IACA,cAAA;IACA,wBAAA;EAvDJ;EAyDI;IACE,uBAAA;IACA,2BAAA;IACA,mBAAA;EAvDN;EAyDI;IACE,YAAA;EAvDN;EAyDI;IACE,eAAA;EAvDN;EAyDM;IACE,eAAA;EAvDR;EA0DI;IACE,aAAA;EAxDN;EA2DE;;IAEE,oBAAA;EAzDJ;EA2DI;;IACE,eAAA;EAxDN;EA4DI;IACE,SAAA;EA1DN;AACF;AA6DE;EACE;IACE,WAAA;IACA,8BAAA;EA3DJ;EA6DI;IACE,WAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,SAAA;IACA,iBAAA;EA3DN;EA6DM;IAEE,YAAA;IACA,2KACE;EA7DV;EAmEM;IACE,cAAA;IACA,eAAA;EAjER;EAmEQ;IACE,WAAA;IACA,0DAAA;IACA,6BAAA;EAjEV;EAqEM;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,gBAAA;IACA,oBAAA;IACA,UAAA;IACA,sBAAA;EAnER;EAuEQ;IACE,gBAAA;IACA,eAAA;EArEV;EAwEQ;IACE,cAAA;IACA,YAAA;EAtEV;EA4EQ;IACE,eAAA;IACA,cAAA;EA1EV;EA6EQ;IACE,eAAA;IACA,cAAA;IACA,UAAA;IACA,oBAAA;IACA,iBAAA;IACA,kBAAA;EA3EV;EA+EU;IACE,cAAA;IACA,eAAA;EA7EZ;EAgFU;IACE,YAAA;IACA,eAAA;EA9EZ;EAiFU;IACE,eAAA;IACA,eAAA;EA/EZ;EAqFQ;IACE,UAAA;EAnFV;EAwFI;IACE,WAAA;IACA,mBAAA;IACA,oBAAA;IACA,8BAAA;EAtFN;EAyFI;IACE,WAAA;EAvFN;EAgGE;IACE,UAAA;EA9FJ;EAgGI;IACE,gBAAA;IACA,mBAAA;EA9FN;EAiGE;IACE,UAAA;IACA,oBAAA;EA/FJ;EAiGI;IACE,gBAAA;IACA,kBAAA;EA/FN;EAkGI;IACE,eAAA;IACA,gBAAA;IACA,yBAAA;EAhGN;EAmGE;IACE,gBAAA;EAjGJ;EAmGE;IACE,kBAAA;EAjGJ;EAmGE;IACE,aAAA;EAjGJ;AACF;AAqGE;EACE;;;;;;;IAOE,eAAA;IACA,gBAAA;EAnGJ;EAsGE;IACE,eAAA;IACA,eAAA;EApGJ;AACF","sourcesContent":[".home-page {\n  @keyframes home-ad-enter {\n    from {\n      opacity: 0;\n      transform: translate3d(0, 18px, 0) scale(0.98);\n    }\n\n    to {\n      opacity: 1;\n      transform: translate3d(0, 0, 0) scale(1);\n    }\n  }\n\n  @keyframes home-ad-enter-sync {\n    from {\n      opacity: 0;\n      transform: translate3d(12px, 0, 0) scale(0.985);\n    }\n\n    to {\n      opacity: 1;\n      transform: translate3d(0, 0, 0) scale(1);\n    }\n  }\n\n  position: relative;\n  width: 100%;\n  padding: 24px 0 0;\n\n  .title-home, .title-section {\n    font: {\n      family: Campuni, Figtree, \"Open Sans\";\n      size: 16px;\n      weight: 700;\n    }\n    color: var(--sebrae-blue-6);\n    margin-bottom: 30px;\n  }\n  p {\n    font-size: 13px;\n    line-height: 1.3;\n  }\n  picture {\n    margin: 32px 0;\n\n    img {\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n  .card-projected {\n    padding: 0 7px;\n    height: 70px;\n\n    &-content {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      gap: 8px;\n    }\n    figure {\n      position: absolute;\n      bottom: -5px;\n      left: 0;\n      width: 100px;\n    }\n    .text {\n      max-width: 62%;\n    }\n    h2 {\n      font-size: 14px;\n      margin-bottom: 5px;\n    }\n    p {\n      font-size: 11px;\n    }\n  }\n  .line {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background:  var(--sebrae-light-gray4);\n    margin: 32px 0;\n  }\n  .content {\n    margin-bottom: 30px;\n\n    .salutation {\n      margin-bottom: 32px;\n\n      h2 {\n        font-size: 32px;\n        font-weight: 700;\n        font-family: \"Campuni\";\n        color: var(--sebrae-gray);\n\n        span {\n          color: var(--sebrae-blue);\n        }\n      }\n    }\n\n    &-left {\n      margin-bottom: 24px;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      &__hero-panel,\n      &__ad-panel {\n        min-width: 0;\n      }\n\n      &__hero-panel {\n        transition: width 700ms ease, flex-basis 700ms ease, max-width 700ms ease;\n      }\n\n      &__ad-panel {\n        width: 100%;\n      }\n\n      &--ad-animating {\n        .home-hero__content picture {\n          transition: opacity 520ms ease;\n          opacity: 0;\n        }\n\n        .home-hero__image {\n          transition: opacity 520ms ease;\n          opacity: 0;\n        }\n      }\n\n      &__ad-slot {\n        width: 100%;\n        transform-origin: center;\n        will-change: opacity, transform;\n        opacity: 1;\n\n        .transbordo-ad {\n          container-type: inline-size;\n          max-width: 571px !important;\n        }\n\n        .transbordo-ad__close {\n          font-size: 20px !important;\n        }\n\n        .transbordo-ad__cta {\n          width: 100% !important;\n        }\n\n        @media screen and (max-width: 641px) {\n          .transbordo-ad[data-rule-key=\"G1\"] {\n            max-width: none !important;\n            width: 100% !important;\n          }\n\n          .transbordo-ad[data-rule-key=\"G1\"] + .transbordo-ad__aside {\n            display: none !important;\n          }\n        }\n\n        @container (max-width: 530px) {\n          .transbordo-ad__actions {\n            flex-direction: column !important;\n            gap: 12px !important;\n          }\n        }\n\n        &--entering {\n          animation: home-ad-enter-sync 700ms ease both;\n        }\n      }\n    }\n\n    &-middle {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      margin-bottom: 24px;\n    }\n  }\n  .things-to-do,\n  .simulations {\n    background: var(--sebrae-white);\n    box-shadow: 0px 4px 4px 0px #0000001A;\n    border: 1px solid var(--sebrae-light-gray4);\n    border-radius: 8px;\n    padding: 24px 16px;\n  }\n  .things-to-do {\n    &__list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    &__item {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      padding: 16px 12px;\n      border-radius: 10px;\n      background: #f1f6ff;\n\n      p {\n        margin: 0;\n        font-size: 16px;\n        color: var(--sebrae-blue-2);\n      }\n    }\n\n    &__icon {\n      flex-shrink: 0;\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n      background: #84F4BC;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        display: block;\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    &__link {\n      display: block;\n      width: 100%;\n      margin-top: 16px;\n      border: 0;\n      color: var(--sebrae-blue);\n      font-size: 16px;\n      font-weight: 700;\n      text-align: center;\n    }\n  }\n  .simulations {\n    p {\n      margin-bottom: 24px;\n    }\n\n    .comparison-lab-container {\n      max-width: 100%;\n      gap: 0;\n      margin-bottom: 24px;\n      \n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      svg {\n        width: 100%;\n        height: auto;\n        margin-left: 0;\n      }\n    }\n\n    .card-pill {\n      max-width: 100%;\n      border: 0;\n      box-shadow: none;\n    }\n  }\n  .card-pill.right {\n    .card-pill__text {\n      background: transparent;\n    }\n  }\n  .modal-default {\n    &.dialog-alert {\n      .title {\n        font-size: 16px;\n      }\n      .wrapper-modal {\n        max-width: 405px;\n      }\n      .dialog-alert {\n        &__description {\n          font-size: 14px;\n\n          strong {\n            font-size: inherit;\n          }\n        }\n        &__buttons {\n          display: flex;\n          justify-content: flex-end;\n          gap: 24px;\n          margin-top: 24px;\n\n          button {\n            min-height: 32px;\n            padding: 5px 12px;\n          }\n          span {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n\n\n  @media screen and (min-width: 375px) {\n    .card-projected {\n      height: 87px;\n      padding: 0 10px;\n\n      figure {\n        width: 125px;\n        left: 10px;\n      }\n      .text {\n        max-width: 58%;\n      }\n      h2 {\n        font-size: 16px;\n      }\n    }\n  }\n  @media screen and (min-width: 768px) {\n    .title-home {\n      font-size: 28px;\n    }\n    p {\n      font-size: 16px;\n\n      strong {\n        font-size: 24px;\n      }\n    }\n    .title-section {\n      font-size: 23px;\n    }\n    .card-projected {\n      width: 98%;\n      margin: 0 auto;\n      transform: skewX(-10deg);\n\n      &-content {\n        transform: skewX(10deg);\n        justify-content: flex-start;\n        padding-left: 150px;\n      }\n      figure {\n        bottom: -7px;\n      }\n      .text {\n        max-width: 100%;\n\n        p {\n          font-size: 13px;\n        }\n      }\n      .border {\n        display: none;\n      }\n    }\n    .things-to-do,\n    .simulations {\n      padding: 37.5px 24px;\n\n      .title-section {\n        font-size: 27px;\n      }\n    }\n    .things-to-do {\n      &__item {\n        gap: 16px;\n      }\n    }\n  }\n  @media screen and (min-width: 992px) {\n    .content {\n      width: 100%;\n      justify-content: space-between;\n\n      &-left {\n        width: 100%;\n        max-width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 16px;\n        overflow: visible;\n\n        &__hero-panel,\n        &__ad-panel {\n          min-width: 0;\n          transition:\n            flex-basis 700ms cubic-bezier(0.22, 1, 0.36, 1),\n            max-width 700ms cubic-bezier(0.22, 1, 0.36, 1),\n            width 700ms cubic-bezier(0.22, 1, 0.36, 1),\n            opacity 420ms ease;\n        }\n\n        &__hero-panel {\n          flex: 0 1 100%;\n          max-width: 100%;\n\n          .home-hero {\n            width: 100%;\n            transition: transform 700ms cubic-bezier(0.22, 1, 0.36, 1);\n            transform-origin: left center;\n          }\n        }\n\n        &__ad-panel {\n          flex: 0 0 0%;\n          max-width: 0;\n          opacity: 0;\n          overflow: hidden;\n          pointer-events: none;\n          padding: 0;\n          box-sizing: border-box;\n        }\n\n        &--has-pending-ad {\n          .content-left__hero-panel {\n            flex-basis: 100%;\n            max-width: 100%;\n          }\n\n          .content-left__ad-panel {\n            flex-basis: 0%;\n            max-width: 0;\n          }\n        }\n\n        &--ad-animating,\n        &--ad-visible {\n          .content-left__hero-panel {\n            flex-basis: 58%;\n            max-width: 58%;\n          }\n\n          .content-left__ad-panel {\n            flex-basis: 42%;\n            max-width: 42%;\n            opacity: 1;\n            pointer-events: auto;\n            overflow: visible;\n            padding: 12px 10px;\n          }\n\n          .home-hero__content {\n            picture.home-hero__media {\n              width: 480.2px;\n              max-width: none;\n            }\n\n            picture.home-hero__media--monitoring-reminder {\n              width: 700px;\n              max-width: none;\n            }\n\n            picture.home-hero__media--monitoring-overdue {\n              width: 789.14px;\n              max-width: none;\n            }\n          }\n        }\n\n        &--ad-visible {\n          .home-hero__content picture {\n            opacity: 0;\n          }\n        }\n      }\n\n      &-middle {\n        width: 100%;\n        flex-direction: row;\n        align-items: stretch;\n        justify-content: space-between;\n      }\n\n      > div:last-child {\n        width: 100%;\n      }\n\n      // &.has-plannings {\n      //   .widget-pills {\n      //     padding-top: 48px;\n      //   }\n      // }\n    }\n    .things-to-do {\n      width: 60%;\n\n      .title-section {\n        text-align: left;\n        margin-bottom: 24px;\n      }\n    }\n    .simulations {\n      width: 40%;\n      padding: 37.5px 24px;\n\n      .title-section {\n        text-align: left;\n        margin-bottom: 8px;\n      }\n\n      p {\n        font-size: 13px;\n        font-weight: 400;\n        color: var(--sebrae-gray);\n      }\n    }\n    .card-projected {\n      margin-top: 51px;\n    }\n    .card-pill {\n      border-radius: 4px;\n    }\n    .line {\n      display: none;\n    }\n\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .content-left,\n    .content-left__ad-slot,\n    .content-left__hero-panel,\n    .content-left__ad-panel,\n    .content-left--ad-animating .home-hero,\n    .content-left--ad-animating .home-hero__content picture,\n    .content-left--ad-animating .home-hero__image {\n      animation: none;\n      transition: none;\n    }\n\n    .content-left__ad-slot {\n      animation: none;\n      transform: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
